import React from 'react';
import { Button, Typography } from '@mui/material';

const FieldActionButton = ({
  onClick,
  IconComponent,
  label,
  color,
  enabled = true,
  visibilityControl = true, // 👈 determines whether to render
}) => {
  // 🚫 Do not render anything if not visible
  if (!visibilityControl) return null;

  return (
    <Button
      onClick={enabled ? onClick : undefined}
      disabled={!enabled}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
        background: 'transparent',
        color: 'var(--app-color)',
        cursor: enabled ? 'pointer' : 'not-allowed',
        borderRadius: '10px',
        height: '58px',
        ':hover': enabled
          ? {
              backgroundColor: '#F0F4F4',
              color: '#2b4252',
            }
          : {},
      }}
    >
      <IconComponent
        sx={{
          fontSize: 30,
          marginTop: 1,
          marginBottom: '5px',
          color: color || 'var(--app-color)',
          padding: 0,
        }}
      />
      <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">
        {label}
      </Typography>
    </Button>
  );
};

export default FieldActionButton;
